import React, { lazy, useEffect, useState } from 'react';

import AppLayout from '../components/Layout/RootLayout';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Login from '../Views/Login/Login';
import LogOut from '../Views/Logout/Logout';
import ActivePremiseMeterDetail from '../Views/ActivePremiseMeter/[id]';
import UpdateProfile from '../Views/Setting/RoleManagement/UpdateProfile';
import { useCookies } from 'react-cookie';
import DailyUsage from '../Views/AlarmErrorManagement/MeterSNDetail.jsx';
import CaseListingPage from '../Views/Workforce/CaseListing/CaseListingPage';
import CreateCasePage from '../Views/Workforce/CreateCase/CreateCasePage';
import WorkforceDashboardPage from '../Views/Workforce/Dashboard/DashboardPage';
import TechnicianListingPage from '../Views/Workforce/TechnicianListing/TechnicianListingPage';
import TechnicianManagementPage from '../Views/Workforce/TechnicianManagement/TechnicianManagementPage';
import CaseListingDetailsPage from '../Views/Workforce/CaseListingDetails/CaseListingDetailsPage';
import SystemMeterAnalysisPage from '../Views/SystemAnalysis/MeterAnalysis/SystemMeterAnalysisPage';
import ForgotPassword from '../Views/ForgotPassword/ForgotPassword';

const Announcements = lazy(() => import('../Views/Workforce/Announcement/AnnouncementPage'));
const OverallSummary = lazy(() => import('../Views/OverallSummary/OverallSummaryPage'));
const ActivePremiseMeter = lazy(() => import('../Views/ActivePremiseMeter/ActivePremiseMeter'));
const GoogleMapPage = lazy(() => import('../Views/GoogleMap/GoogleMapPage'));
const AlarmErrorManagement = lazy(
  () => import('../Views/AlarmErrorManagement/AlarmErrorManagement')
);
const AlarmErrorManagementDetail = lazy(() => import('../Views/AlarmErrorManagement/[id]'));
const SystemAnalysis = lazy(() => import('../Views/SystemAnalysis/SystemAnalysis'));
const SystemRecords = lazy(() => import('../Views/SystemRecords/SystemRecords'));
const Workforce = lazy(() => import('../Views/Workforce/Workforce'));
const PurchaseCost = lazy(() => import('../Views/PurchaseCost/PurchaseCost'));
const Inventory = lazy(() => import('../Views/Inventry/Inventory'));
const AuditTrail = lazy(() => import('../Views/AuditTrail/AuditTrail'));
const RoleManagement = lazy(() => import('../Views/Setting/RoleManagement/RoleManagement'));
const AddUser = lazy(() => import('../Views/Setting/AddUser'));
const ChangePassword = lazy(() => import('../Views/Setting/ChangePassword'));
const PageNotFound = lazy(() => import('../Views/PageNotFound'));

function MainRoute() {
  const navigate = useNavigate();
  const [, setIsLoading] = useState(true);
  const [cookies] = useCookies(['jwtToken']);

  const checkIfLogin = () => {
    if (cookies?.jwtToken) {
      setIsLoading(false);
    } else {
      navigate('/login');
      setIsLoading(false);
    }
  };
  useEffect(() => {
    checkIfLogin();
  }, []);

  return (
    <>
      <Routes>
        <Route path="logout" element={<LogOut />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<OverallSummary />} />
          <Route path="/active-premise-meter" element={<ActivePremiseMeter />} />
          <Route path="/active-premise-meter/:id" element={<ActivePremiseMeterDetail />} />
          <Route path="/active-premise-meter/daily-usage/:id" element={<DailyUsage />} />
          <Route path="/active-premise-meter/map-location" element={<GoogleMapPage />} />
          <Route path="/alarm-error-management" element={<AlarmErrorManagement />} />
          <Route path="/alarm-error-management/:id" element={<AlarmErrorManagementDetail />} />
          <Route path="/alarm-error-management/daily-usage/:id" element={<DailyUsage />} />
          <Route path="/alarm-error-management/map-location" element={<GoogleMapPage />} />
          <Route path="/system-records" element={<SystemRecords />} />
          <Route path="/workforce" element={<Workforce />} />
          <Route path="/purchase-cost" element={<PurchaseCost />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/audit-trail" element={<AuditTrail />} />
          <Route path="/role-management" element={<RoleManagement />} />
          {/* <Route path="/role-management/new" element={<NewRoleManagement />} /> */}
          <Route path="/role-management/update-profile" element={<UpdateProfile />} />
          <Route path={'/announcements'} element={<Announcements />} />
          <Route path="/users" element={<AddUser />} />
          <Route path="/setting/change-password" element={<ChangePassword />} />

          {/* System Analysis */}
          <Route path="/system-analysis-dashboard" exact element={<SystemAnalysis />} />
          <Route path="/system-analysis/analysis" element={<SystemMeterAnalysisPage />} />
          <Route path="/system-analysis/:analysisType" element={<SystemAnalysis />} />
          <Route
            path={'/system-analysis/analysis/individual-analysis/:serialNumber'}
            element={<SystemMeterAnalysisPage />}
          />

          {/* Workforce  */}
          <Route path="/wf-dashboard" exact element={<WorkforceDashboardPage />} />
          <Route path="/wf-case-listing" element={<CaseListingPage />} />
          <Route path="/wf-case-listing-details/:id" element={<CaseListingDetailsPage />} />
          <Route path="/wf-create-case" element={<CreateCasePage />} />
          <Route path="/wf-create-case/:id" element={<CreateCasePage />} />
          <Route path="/wf-technician-listing" element={<TechnicianListingPage />} />
          <Route path={'/wf-technician-management'} element={<TechnicianManagementPage />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default MainRoute;
